// extracted by mini-css-extract-plugin
module.exports = {"loginBtn":"authHeader_loginBtn__2YHqa"};